export function formatMovementQuantity(quantity: unknown, unitName?: string | null): string {
  if (quantity === null || quantity === undefined || quantity === '') return '-'
  const value = Number(quantity)
  if (!Number.isFinite(value)) return String(quantity)
  const formatted = value % 1 === 0
    ? new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(value)
    : new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
  return unitName ? `${formatted}${unitName.toLowerCase()}` : formatted
}

interface MovementDirectionSource {
  oldTotalWeight?: number | string | null
  newTotalWeight?: number | string | null
  oldLengthInMm?: number | string | null
  newLengthInMm?: number | string | null
  oldQuantity?: number | string | null
  newQuantity?: number | string | null
  status?: unknown
}

export function getMovementDirection(movement: MovementDirectionSource): 'IN' | 'OUT' {
  const oldW = Number(movement.oldTotalWeight ?? 0)
  const newW = Number(movement.newTotalWeight ?? 0)
  const oldL = Number(movement.oldLengthInMm ?? 0)
  const newL = Number(movement.newLengthInMm ?? 0)
  const oldQ = Number(movement.oldQuantity ?? 0)
  const newQ = Number(movement.newQuantity ?? 0)

  if (Math.abs(newW - oldW) > 1e-6) return newW > oldW ? 'IN' : 'OUT'
  if (Math.abs(newL - oldL) > 1e-6) return newL > oldL ? 'IN' : 'OUT'
  if (Math.abs(newQ - oldQ) > 1e-6) return newQ > oldQ ? 'IN' : 'OUT'
  return String(movement.status ?? '').trim() === '201' ? 'IN' : 'OUT'
}
